import { c as _c } from "react/compiler-runtime";
import React from 'react';
import getCookies from 'commons/getCookies';
import PDPKeySellingPointsV1 from './PDPKeySellingPointsV1';
import PDPKeySellingPointsV2 from './PDPKeySellingPointsV2';
const KSP_V2_KEY = 'v2_ksp';
const PDPKeySellingPoints = () => {
  const $ = _c(4);
  const [useV2, setUseV2] = React.useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const value = getCookies()?.get(KSP_V2_KEY);
      if (value && String(value).trim() === "false") {
        setUseV2(false);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  React.useEffect(t0, t1);
  if (useV2) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <PDPKeySellingPointsV2 />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PDPKeySellingPointsV1 />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default PDPKeySellingPoints;